import { render } from "./OidcCallback.vue?vue&type=template&id=dacb4040&scoped=true&ts=true"
import script from "./OidcCallback.vue?vue&type=script&lang=ts"
export * from "./OidcCallback.vue?vue&type=script&lang=ts"

import "./OidcCallback.vue?vue&type=style&index=0&id=dacb4040&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dacb4040"]])

export default __exports__